import styled from 'styled-components'

import { type IBadgeProps } from '../Badge'

const badgeFontSize = 12
const badgeHeight = 21
const badgePadding = 6
const badgeBorderRadius = 10

export const BadgeStyled = styled.span<IBadgeProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-size: ${(props) => props.theme.typography.pxToRem(badgeFontSize)};
  font-weight: ${(props) => props.theme.fontWeights.semibold};
  line-height: normal;
  height: ${(props) => props.theme.typography.pxToRem(badgeHeight)};
  min-width: ${(props) => props.theme.typography.pxToRem(badgeHeight)};
  padding: 0 ${(props) => props.theme.typography.pxToRem(badgePadding)};
  color: ${(props) => props.theme.colors.text.inverse};
  background-color: ${(props) =>
    props.theme.colors[props.color] || props.theme.colors.primary};
  border-radius: ${(props) =>
    props.theme.typography.pxToRem(badgeBorderRadius)};
`
